import { commonHeaders } from "../ClientResources";
import { deviceLinkLocalhostRoot } from "./Applications";

export enum EcgFileOpenResult {
    FailedToLoad = 0,
    RhythmOnly = 1,
    RepresentativeBeat = 2,
    GraphicsLoaded = 3
}

export interface LeadAnnotation {
    annotation: string;
    leadIndex: number;
    beatIndex: number;
    value: number;
}

export enum CalEcgPermissions {
    ModifyDemographics = "MoDemog",
    ViewDemographics = "ViewDemog",
    MoveAnnotations = "MoAnn",
    MarkLocalAnnotationsRhythm = "MkNwLocECGAnn",
    MarkGlobalAnnotationsRhythm = "MkNwGblECGAnn",
    MarkLocalAnnotationsRepBeat = "MkNwLocRPAnn",
    MarkGlobalAnnotationsRepBeat = "MkNwGblRPAnn",
    DeleteAnnotations = "DeAnn",
    MarkAnnotationsWithLowPixelToSampleRatio = "MkAnnRL",
    RunSemiAutomaticMode = "RuSeAut",
    CreateMedianBeats = "MkMedian",
    ModifyHeartRate = "MoHR",
    ComputeHeartRate = "AutoHR",
    AutomaticInterpretation = "RunAutInter",
    AutomaticAxes = "RunAutAxes",
    SelectRRMeasurements = "ModRRPlacing",
    SelectTPeakandTOff = "ModTpeakToffPlacing",
    All = "All"
}

export const OpenEcg = (appId: string, hl7Base64String: string): Promise<EcgFileOpenResult> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications/${appId}/openecg`, {
        method: 'POST',
        ...commonHeaders,
        body: JSON.stringify(hl7Base64String),
    })
        .then(response => response.json());
}

export const Protocol = (appId: string): Promise<boolean> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications/${appId}/protocol`, {
        method: 'POST',
        ...commonHeaders,
    })
        .then(response => response.ok);
}

export const ShowWindow = (appId: string, isMaximized: boolean): Promise<boolean> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications/${appId}/showwindow`, {
        method: 'POST',
        ...commonHeaders,
        body: JSON.stringify(isMaximized),
    })
        .then(response => response.ok);
}

export const ShowAllWindows = (appId: string): Promise<boolean> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications/${appId}/showallwindows`, {
        method: 'POST',
        ...commonHeaders
    })
        .then(response => response.ok);
}

export const CloseApplication = (appId: string): Promise<boolean> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications/${appId}/closeapplication`, {
        method: 'POST',
        ...commonHeaders,
    })
        .then(response => response.ok);
}

export const GetAnnotations = (appId: string): Promise<any> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications/${appId}/getannotations`, {
        method: 'POST',
        ...commonHeaders,
    })
        .then(response => response.json());
}

export const ExportEcgToBase64 = (appId: string, format: number): Promise<string> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications/${appId}/exportecgtobase64`, {
        method: 'POST',
        ...commonHeaders,
        body: JSON.stringify({
            fullFileName: "",
            format: format
        }),
    })
        .then(response => response.json());
}

export const ImportAnnotationsTextFile = (appId: string, base64FileContent: string): Promise<number> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications/${appId}/importannotationstextfile`, {
        method: 'POST',
        ...commonHeaders,
        body: JSON.stringify(base64FileContent),
    })
        .then(response => response.json());
}

export const SetTitle = (appId: string, title: string): Promise<boolean> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications/${appId}/settitle`, {
        method: 'POST',
        ...commonHeaders,
        body: JSON.stringify(title),
    })
        .then(response => response.ok);
}

export const SetPermission = (appId: string, permission: string, enabled: boolean): Promise<boolean> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications/${appId}/setpermission`, {
        method: 'POST',
        ...commonHeaders,
        body: JSON.stringify({
            permission: permission,
            enabled: enabled,
        }),
    })
        .then(response => response.ok);
}

export const AddTransmittal = (appId: string, testId: string): Promise<boolean> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications/${appId}/addtransmittal`, {
        method: 'POST',
        ...commonHeaders,
        body: JSON.stringify(testId),
    })
        .then(response => response.ok);
}

export const SetDigitalDefaults = (appId: string): Promise<boolean> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications/${appId}/setdigitaldefaults`, {
        method: 'POST',
        ...commonHeaders,
        body: JSON.stringify({}),
    })
        .then(response => response.ok);
}
